"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguagesMetadata = void 0;
var _shared = require("@ori-appshell/shared");
var _getAlternateLanguageUrl = require("../internals/getAlternateLanguageUrl");
var _jsxRuntime = require("react/jsx-runtime");
const LanguagesMetadata = ({
  languages,
  host,
  pathname
}) => {
  let pathnameWithoutLanguage = pathname;
  for (const language of languages) {
    const languageAsString = (0, _shared.getLanguageFromLanguageCode)(language.code);
    const languageAsPathPart = `/${languageAsString}/`;
    if (pathname.startsWith(languageAsPathPart)) {
      pathnameWithoutLanguage = pathnameWithoutLanguage.replace(languageAsPathPart, '/');
      break;
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: languages.map(lang => /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      rel: "alternate",
      hrefLang: (0, _shared.getLanguageFromLanguageCode)(lang.code),
      href: (0, _getAlternateLanguageUrl.getAlternateLanguageUrl)(host, lang, pathnameWithoutLanguage)
    }, lang.code))
  });
};
exports.LanguagesMetadata = LanguagesMetadata;
